import { useQuery } from '@tanstack/react-query'
import { useTranslations } from 'next-intl'

import { roomQueries } from '@/entities/room'
import { cn } from '@/shared/lib'
import { Spinner } from '@/shared/ui'

import { RecentRoomItem } from './item'
import { Item, List } from '../popup/common'

export const RecentRoomList = () => {
  const t = useTranslations('search_panel')

  const { isFetching, data: recentRooms } = useQuery({
    ...roomQueries.recentViewedRooms(),
    staleTime: 1000 * 60,
  })

  const noRecentRooms = recentRooms?.length === 0

  return (
    <List title={t('recent_room.title')} className="relative w-[400px]">
      {(() => {
        if (isFetching) return <Spinner />

        if (noRecentRooms)
          return (
            <div className="flex h-full w-full flex-col items-center justify-center">
              <p className="typo-body1 font-normal text-gray-400">
                {t('recent_room_empty')}
              </p>
            </div>
          )

        return recentRooms?.map(room => (
          <Item
            key={room.rid}
            className={cn('border-b border-gray-100 p-0')}
            data-item-type="recent-room"
          >
            <RecentRoomItem
              href={`/guest/room/${room.rid}`}
              target="_blank"
              room={room}
            />
          </Item>
        ))
      })()}
    </List>
  )
}
